import type { Depth, StatisticData, ThemeStatisticData } from '@/entities/insight';
import { PostFilter } from '../../../../entities/post/models';

import { getNextDimension } from '../../shared/helpers/get-next-dimension';

export function getActionColumnOptionForUnified(
  currentDepth: Depth | null,
  addDepth: (depth: Depth, sentiment?: string) => void,
) {
  const targetDimension = getNextDimension(currentDepth?.dimension || null);
  if (!targetDimension) return;
  const nextTargetDimension = getNextDimension(targetDimension);
  if (!nextTargetDimension) return;

  return {
    getButtonText: (row: StatisticData | ThemeStatisticData) => {
      const childrenCount = row.children?.length || 0;
      return `See ${nextTargetDimension} (${childrenCount})`;
    },
    isDisabled: (row: StatisticData | ThemeStatisticData) => {
      return row.children === null || (row.children?.length || 0) === 0;
    },
    onClick: (_: React.MouseEvent, row: StatisticData | ThemeStatisticData) => {
      // Extract sentiment if it's a theme row
      const sentiment = 'sentiment' in row ? row.sentiment : undefined;

      addDepth(
        {
          dimension: targetDimension,
          value: row.name,
          sentiment,
        },
        sentiment,
      );
    },
  };
}

export function getDimensionIcon(dimension: string): string {
  switch (dimension) {
    case PostFilter.Theme:
      return '#'; // Will be replaced by sentiment-specific icons
    case PostFilter.Brand:
      return '🏷️';
    case PostFilter.Product:
      return '📦';
    default:
      return '#';
  }
}

export function getThemeIcon(sentiment: string): string {
  switch (sentiment) {
    case 'positive':
      return '👍';
    case 'negative':
      return '👎';
    default:
      return '#'; // for 'all' tab
  }
}

export function getColumnHeader(
  currentLevel: 'theme' | 'brand' | 'product',
  targetDimension: string | null,
): string {
  if (currentLevel === 'theme') {
    switch (targetDimension) {
      case PostFilter.Brand:
        return 'Brands mentioned';
      default:
        return 'Related items';
    }
  }

  if (currentLevel === 'brand') {
    switch (targetDimension) {
      case PostFilter.Product:
        return 'Products mentioned';
      default:
        return 'Related items';
    }
  }

  // Product level has no children
  return '';
}
